import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import {
    makeGETRequestOnUserService,
    makePUTRequestOnUserService,
} from "../../Api/api";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { StyledTextInput } from "../StyledComponents/StyledInputs";
import Button from "@mui/material/Button";
import toastr from "toastr";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { UserUCCDetails, Ucckycdetail } from "../Users/UpdateUCC";


const PartnerClientUpdateUCC = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const user_type = queryParams.get("user_type") || "partner";
    const [userUCCDetails, setUserUCCDetails] = useState<UserUCCDetails | null>(
        null
    );
    const [loading, setLoading] = useState(true);
    const {
        userUUID,
    }: {
        userUUID: string;
    } = useParams();

    useEffect(() => {
        let active = true;
        if (!loading) {
            return undefined;
        }
        makeGETRequestOnUserService(
            `/partneruser/ucc_api_response/get/${userUUID}/?user_type=${user_type}`
        )
            .then((resp) => {
                if (active && resp.status == 200) {
                    setUserUCCDetails(resp.data);
                }
            })
            .catch((error) => toastr.error(error))
            .finally(() => {
                active && setLoading(false);
            });
        return () => {
            active = false;
        };
    }, [loading]);

    const handleUpdateUCC = () => {
        makePUTRequestOnUserService(
            `/order_management_v2/ucc_api_response/update/${userUUID}/`,
            {
                json_data: userUCCDetails,
                user_type: user_type,
                admin_name: JSON.parse(localStorage.getItem("loginUser")!)?.name,
            }
        )
            .then((resp) => {
                if (resp.status === 200 && resp.data.success) {
                    toastr.success("UCC Details Updated Successfully!");
                } else {
                    toastr.error("Something went wrong. Please try again later.");
                }
            })
            .catch((error) => toastr.error(error));
    };

    return (
        <Box sx={{ maxWidth: ["90%", "80%"], mx: "auto", my: 5 }}>
            <Button
                sx={{ mb: 2 }}
                variant="contained"
                startIcon={<ExpandMoreIcon sx={{ rotate: "90deg" }} />}
                href="/partners_users"
            >
                View All{" "}
                {user_type.charAt(0).toUpperCase() + user_type.slice(1)} Users
            </Button>
            {loading ? (
                <Box
                    sx={{
                        height: "70vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <CircularProgress
                        color="error"
                        size={70}
                        thickness={5}
                    />
                </Box>
            ) : userUCCDetails ? (
                <>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 2,
                        }}
                    >
                        <Box sx={{ bgcolor: "#FFFFFF", p: 2, borderRadius: 5 }}>
                            <Grid container spacing={1}>
                                {Object.keys(userUCCDetails.UCCKYCDETAILS[0]).map(
                                    (item, index) => (
                                        <Grid item xs={6} key={index}>
                                            <FormControl fullWidth variant="standard">
                                                <InputLabel shrink htmlFor={item}>
                                                    {item
                                                        .replace(/([A-Z])/g, " $1")
                                                        .replace(/^./, (str) => str.toUpperCase())}
                                                </InputLabel>
                                                <StyledTextInput
                                                    id={`${item}_${index}`}
                                                    name={item}
                                                    value={
                                                        userUCCDetails.UCCKYCDETAILS[0][
                                                        item as keyof Ucckycdetail
                                                        ]
                                                    }
                                                    onChange={(event) => {
                                                        const value = event.target.value;
                                                        setUserUCCDetails((prev) => ({
                                                            _id: prev?._id as string,
                                                            user_id: prev?.user_id as string,
                                                            UCCKYCDETAILS: [
                                                                {
                                                                    ...prev!.UCCKYCDETAILS[0],
                                                                    [item as keyof Ucckycdetail]: value,
                                                                },
                                                            ],
                                                        }));
                                                    }}
                                                />
                                            </FormControl>
                                        </Grid>
                                    )
                                )}
                            </Grid>
                        </Box>
                        <Button
                            variant="contained"
                            size="large"
                            fullWidth={false}
                            onClick={() => handleUpdateUCC()}
                        >
                            Update UCC
                        </Button>
                    </Box>
                </>
            ) : (
                <Typography textAlign="center">
                    Error Fetching UCC Details, Pls check with backend
                </Typography>
            )}
        </Box>
    );
};

export default PartnerClientUpdateUCC;